import { h } from '@stencil/core';
import cn from 'classnames';
export class PesSoftwareModalCell {
  constructor() {
    this.type = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: cn('pes-software-modal-cell', this.type && `pes-software-modal-cell--${this.type}`) }, h("slot", null)));
  }
  static get is() { return "pes-software-modal-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-software-modal-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-software-modal-cell.css"]
    };
  }
  static get properties() {
    return {
      "type": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "PESSoftwareModalColumnType",
          "resolved": "\"date\" | \"format\" | \"language\" | \"link\" | \"onlineLink\" | \"os\" | \"size\" | \"versions\"",
          "references": {
            "PESSoftwareModalColumnType": {
              "location": "import",
              "path": "../pes-software-modal-content/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines cell type by. Used in styling."
        },
        "attribute": "type",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
